import supabase from './supabaseClient';

// Single source of truth for building public Supabase Storage URLs.
// Replaces the hardcoded `https://<ref>.supabase.co/storage/v1/object/public/...`
// literals that were previously copy-pasted across pages and components.

/**
 * Public URL for an object inside a Storage bucket.
 * @param {string} bucket - bucket name (e.g. 'productsamples', 'resources')
 * @param {string} path - object path within the bucket
 * @returns {string} fully-qualified, URL-encoded public URL
 */
export const storagePublicUrl = (bucket, path = '') => {
  const clean = String(path).replace(/^\/+/, '');
  return supabase.storage.from(bucket).getPublicUrl(clean).data.publicUrl;
};

// Default/fallback images used when a record has no thumbnail of its own.
export const DEFAULT_THUMB_URL = storagePublicUrl(
  'productsamples',
  'thumbnails/default/logo512.png'
);

export const DEFAULT_PRODUCT_THUMB_URL = storagePublicUrl(
  'productsamples',
  'thumbnails/default/thumbnail.png'
);
